import React from 'react';

function GamesView() {
  return (
    <div className="games-view">
      <div className="container">
        <h2>Today's Games</h2>
        <p>View live games and odds</p>
      </div>
    </div>
  );
}

export default GamesView;
